import { PERMISSIONS } from "@lib/permissions/permissions.generated";
import { createFileRoute } from "@tanstack/react-router";
import { Truck } from "lucide-react";
import ExpeditionsManager from "@/features/ventes/components/expeditions/ExpeditionsManager";

export const Route = createFileRoute("/_app/ventes/expeditions/")({
  staticData: {
    title: "Expéditions",
    icon: Truck,
    tab_icon: Truck,
    permission: PERMISSIONS.VENTES.EXPEDITIONS.VIEW,
    module: "ventes",
    order: 40,
    showInTab: true,
    showInNav: true,
    showInBreadcrumb: true,
    description: "Gestion des expéditions",
  },
  component: ExpeditionsManager,
});
